import { FC, PropsWithChildren, useState } from 'react'

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
  padding?: string
}

export const PlayerButton: FC<PropsWithChildren<Props>> = ({ children, onClick, padding }) => {
  const [hover, setHover] = useState(false)

  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)}
      onBlur={() => setHover(false)}
      style={{
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
        color: 'white',
        textShadow: '0 0 2px rgba(0, 0, 0, .5)',
        opacity: hover ? 0.86 : 0.7,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: padding ? padding : 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {children}
    </button>
  )
}
